import { styled, Chip, ChipProps } from "@mui/material";
import { AssetLayerAlphaColor, GetAssetObjectReadableLayer } from "../../../../Utils/helpers";
import { ObjectLayer } from "../../../../Core/Api/Types/object-layer";

export interface AssetLayerChipProps extends ChipProps {
  layer: ObjectLayer;
  uncolored?: boolean;
}

const AssetLayerChip: React.FC<AssetLayerChipProps> = (props) => {
  const { layer, uncolored = false, ...otherProps } = props;
  //   let _icon = <AssetIcon layer={layer} />;
  let _label = GetAssetObjectReadableLayer(layer);
  return <StyledChip layer={layer} uncolored={uncolored} /*icon={_icon}*/ label={_label} {...otherProps} />;
};

export default AssetLayerChip;

const StyledChip = styled(Chip, { shouldForwardProp: (prop) => prop !== "layer" && prop !== "uncolored" })<{
  layer: AssetLayerChipProps["layer"];
  uncolored: AssetLayerChipProps["uncolored"];
}>(({ theme, uncolored, layer }) => {
  const styles = {};
  if (uncolored) return { ...styles };
  return {
    ...styles,
    color: theme.palette.text.primary,
    backgroundColor: AssetLayerAlphaColor(layer, 0.65),
    ".MuiSvgIcon-root": { color: theme.palette.text.primary },
  };
});
